import { API_ENV_STATE_KEY, getApiEnvLabel } from '@tapp/utilities/src/apiEnv/apiEnv';

/**
 * Expose which backend env the app is connected to (e.g. `pre-prod`, `test7`) so developers can
 * tell at a glance from the inspector. The label is derived server-side from the server-only
 * `runtimeConfig.API_URL` and serialized to the client via the Nuxt payload — the full URL itself
 * never crosses to the client.
 */
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  useState<string | null>(API_ENV_STATE_KEY, () => {
    // Initializer only runs during SSR; the resolved label is hydrated on the client.
    if (!import.meta.server) return null;
    // Match the override gate: never reveal anything on production deploys.
    if (!import.meta.dev && config.public.STAGE === 'production') return null;
    return getApiEnvLabel(config.API_URL as string);
  });
});
